export const emailMatches = (email, test) =>
  String(email).toLowerCase().trim() === String(test).toLowerCase().trim();

export const isValidEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
};
